import { GD } from "src/GD";

export class PaymentsService {
	constructor() {
		GD.REQ_PAYMENTS.listener = async () => this.getPayments();
	}

	async getPayments(): Promise<IAPIResponse<IPayment[]>> {
		let res: IAPIResponse = { error: { code: -1, message: "No data" } };

		// res = await GD.REQ_API.request({
		// 	method: "clients/list",
		// 	data: {
		// 		acquirer_id: req.acquirerId,
		// 		terminal_id: req.terminalId,
		// 		channel_id: req.channelId,
		// 		project_id: (await GD.REQ_CURRENT_PROJECT.request())?.id,
		// 	},
		// });

		const cards: IPayment[] = [
			// {
			// 	id: 0,
			// 	amount: 0,
			// 	currency: "USD",
			// 	number: "5454545454545454",
			// 	status: "complete",
			// 	iban: "GB33BUKB20201555555555",
			// 	description: "#orderID312313",
			// 	agent: "Agent 1",
			// },
		];

		res = {
			data: cards,
		};

		return res as IAPIResponse<IPayment[]>;
	}
}
